module.exports = __webpack_public_path__ + "images/lms.b308e6f8.webp";